exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".total-cr{\n    text-align:center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/user-credit-transaction-report/user-credit-transaction-report.component.css
// module id = ../../../../../src/app/dashboard/user-credit-transaction-report/user-credit-transaction-report.component.css
// module chunks = main